import { useQuery } from "@tanstack/react-query";
import { getAllLevels } from "../../api/apiLevels";
import i18next from "i18next";

export function useGetLevels(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["levels", page, perPage, filters, i18next.language],
        queryFn: () => getAllLevels(page, perPage, filters),
        retry: false,
    });

    const levels = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };

    return { isLoading, error, levels, meta };
}
